import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import i18n from './lib/i18n';
import { PostHogProvider } from './providers/PostHogProvider';
import { TelemetryProvider } from './providers/TelemetryProvider';
import './styles/globals.css';
import './styles/animations.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TelemetryProvider>
      <I18nextProvider i18n={i18n}>
        <PostHogProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PostHogProvider>
      </I18nextProvider>
    </TelemetryProvider>
  </React.StrictMode>
);
